import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export default function TransactionSideCardRow({ borderBottom, borderTop, label, value }) {
  return (
    <div
      className={classNames('transaction-side-card__row d-flex pb-3', {
        'border-bottom': borderBottom,
        'border-top': borderTop,
        'mb-3': borderBottom,
        'pt-3': borderTop,
      })}
    >
      <b className="flex-1">{label}</b>
      <span className="text-right">{value}</span>
    </div>
  );
}

TransactionSideCardRow.propTypes = {
  borderBottom: PropTypes.bool,
  borderTop: PropTypes.bool,
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
};
